import {
  RUTA_ECHEQUE,
  VISTA_ECHEQUE,
  leerParam,
  rutaEcheq,
} from "./echeqMenu.constants";

export const BANDEJAS_RECHAZO = {
  FINANZAS: "finanzas",
  PAGOS: "pagos",
  JEFE: "jefe",
  CC: "cc",
};

/**
 * Rutas de system_menu (sin slash). Authz UI = menú asignado.
 * Siguen asignadas para prender cada pestaña. El árbol muestra una sola entrada eCheq.
 */
export const MENU_CHEQUES_RECHAZOS = {
  FINANZAS: "cheques_rechazos_finanzas",
  PAGOS: "cheques_rechazos_pagos",
  JEFE: "cheques_rechazos_jefe",
  CC: "cheques_rechazos_cc",
};

export const ORIGEN_RECHAZO = {
  RECLAMO_PROVEEDOR: "reclamo_proveedor",
  EXTRACTO_BANCARIO: "extracto_bancario",
};

export const ESTADOS_RECHAZO = {
  PENDIENTE_FINANZAS_ND: "pendiente_finanzas_nd",
  PENDIENTE_PAGOS: "pendiente_pagos",
  PENDIENTE_JEFE: "pendiente_jefe",
  PENDIENTE_CC: "pendiente_cc",
  CERRADO: "cerrado",
};

export const EMITE_ND_PROVEEDOR = {
  SI: "si",
  NO: "no",
  PENDIENTE: "pendiente",
};

export const TIPOS_ARCHIVO_RECHAZO = {
  EXTRACTO: "extracto",
  ND_PROVEEDOR: "nd_proveedor",
  ND_INTERNA: "nd_interna",
  FICHA_PAGOS: "ficha_pagos",
  ND_CLIENTE: "nd_cliente",
  FACTURA_GASTOS: "factura_gastos",
  OTRO: "otro",
};

export const LABEL_ORIGEN_RECHAZO = {
  reclamo_proveedor: "Reclamo proveedor",
  extracto_bancario: "Extracto bancario",
};

export const LABEL_ESTADO_RECHAZO = {
  pendiente_finanzas_nd: "Pendiente Finanzas (ND)",
  pendiente_pagos: "Pendiente Pagos",
  pendiente_jefe: "Pendiente Jefe",
  pendiente_cc: "Pendiente Cuentas Corrientes",
  cerrado: "Cerrado",
};

export const LABEL_TIPO_ARCHIVO = {
  extracto: "Extracto",
  nd_proveedor: "ND proveedor",
  nd_interna: "ND interna",
  ficha_pagos: "Ficha pagos",
  nd_cliente: "ND cliente",
  factura_gastos: "Factura gastos",
  otro: "Otro",
};

export const ESTADOS_RECHAZO_FILTRO = [
  { value: "", label: "Todos" },
  { value: ESTADOS_RECHAZO.PENDIENTE_FINANZAS_ND, label: LABEL_ESTADO_RECHAZO.pendiente_finanzas_nd },
  { value: ESTADOS_RECHAZO.PENDIENTE_PAGOS, label: LABEL_ESTADO_RECHAZO.pendiente_pagos },
  { value: ESTADOS_RECHAZO.PENDIENTE_JEFE, label: LABEL_ESTADO_RECHAZO.pendiente_jefe },
  { value: ESTADOS_RECHAZO.PENDIENTE_CC, label: LABEL_ESTADO_RECHAZO.pendiente_cc },
  { value: ESTADOS_RECHAZO.CERRADO, label: LABEL_ESTADO_RECHAZO.cerrado },
];

export const TIPOS_ARCHIVO_OPCIONES = Object.entries(LABEL_TIPO_ARCHIVO).map(
  ([value, label]) => ({ value, label })
);

export const labelOrigenRechazo = (origen) =>
  LABEL_ORIGEN_RECHAZO[origen] || origen || "—";

export const labelEstadoRechazo = (estado) =>
  LABEL_ESTADO_RECHAZO[estado] || estado || "—";

export const labelTipoArchivo = (tipo) =>
  LABEL_TIPO_ARCHIVO[tipo] || tipo || "Otro";

export const colorEstadoRechazo = (estado) => {
  const e = String(estado || "").toLowerCase();
  if (e === "cerrado") return "success";
  if (e.includes("jefe")) return "info";
  if (e.includes("pagos")) return "primary";
  if (e.includes("finanzas")) return "warning";
  if (e.includes("pendiente")) return "warning";
  return "default";
};

export const bandejaRechazoDesdePath = (pathname = "", search = "") => {
  const q = leerParam(search, "bandeja");
  if (
    q === BANDEJAS_RECHAZO.FINANZAS ||
    q === BANDEJAS_RECHAZO.PAGOS ||
    q === BANDEJAS_RECHAZO.JEFE ||
    q === BANDEJAS_RECHAZO.CC
  ) {
    return q;
  }
  const path = String(pathname || "");
  if (path.includes("cheques_rechazos_finanzas")) return BANDEJAS_RECHAZO.FINANZAS;
  if (path.includes("cheques_rechazos_pagos")) return BANDEJAS_RECHAZO.PAGOS;
  if (path.includes("cheques_rechazos_jefe")) return BANDEJAS_RECHAZO.JEFE;
  if (path.includes("cheques_rechazos_cc")) return BANDEJAS_RECHAZO.CC;
  if (path.includes(RUTA_ECHEQUE)) return null;
  return BANDEJAS_RECHAZO.CC;
};

export const tituloBandejaRechazo = (bandeja) => {
  if (bandeja === BANDEJAS_RECHAZO.FINANZAS) return "Cheques rechazados — Finanzas";
  if (bandeja === BANDEJAS_RECHAZO.PAGOS) return "Cheques rechazados — Pagos";
  if (bandeja === BANDEJAS_RECHAZO.JEFE) return "Cheques rechazados — Jefe de área";
  return "Cheques rechazados — Cuentas Corrientes";
};

export const rutaBandejaRechazo = (bandeja) =>
  rutaEcheq({ vista: VISTA_ECHEQUE.RECHAZOS, bandeja });

const textoDesdeValor = (valor) => {
  if (typeof valor === "string" && valor.trim()) {
    try {
      const parsed = JSON.parse(valor);
      if (Array.isArray(parsed)) {
        return parsed.filter(Boolean).map(String).join(", ");
      }
    } catch {
      return valor.trim();
    }
    return valor.trim();
  }
  if (Array.isArray(valor) && valor.length) {
    return valor
      .map((m) => {
        if (typeof m === "string") return m;
        return m?.motivo ?? m?.label ?? "";
      })
      .filter(Boolean)
      .join(", ");
  }
  return "";
};

/** Texto canónico (o libre en filas viejas). `codigo_motivo` puede ser null. */
export const textoMotivoRechazo = (row) => {
  if (!row) return "";
  return (
    textoDesdeValor(row.motivo) ||
    textoDesdeValor(row.motivos_rechazo) ||
    textoDesdeValor(row.motivos) ||
    textoDesdeValor(row.ultimo_rechazo?.motivo) ||
    textoDesdeValor(row.ultimo_rechazo?.motivos_rechazo) ||
    textoDesdeValor(row.ultimo_rechazo?.motivos) ||
    ""
  );
};

export const codigoMotivoRechazo = (row) => {
  const raw = row?.codigo_motivo ?? row?.ultimo_rechazo?.codigo_motivo;
  if (raw == null || raw === "") return null;
  const n = Number(raw);
  return Number.isFinite(n) ? n : null;
};

export const MOTIVO_EXENTA_30 = "vencimiento_30_no_propio";

export const esReposicionExenta = (rechazo) => {
  if (rechazo?.reposicion_requerida === false || rechazo?.reposicion_requerida === 0) {
    return true;
  }
  return String(rechazo?.reposicion_exenta_motivo || "") === MOTIVO_EXENTA_30;
};

/** Normaliza badges.rechazos_* y badges.rechazos del GET /cheques/resumen. */
export const badgesRechazosDesdeResumen = (badges = {}) => {
  const nested = badges?.rechazos && typeof badges.rechazos === "object"
    ? badges.rechazos
    : {};
  return {
    rechazos_finanzas: Number(
      badges.rechazos_finanzas ??
        badges.rechazos_finanzas_nd ??
        nested.finanzas ??
        nested.finanzas_nd ??
        0
    ),
    rechazos_pagos: Number(badges.rechazos_pagos ?? nested.pagos ?? 0),
    rechazos_jefe: Number(badges.rechazos_jefe ?? nested.jefe ?? 0),
    rechazos_cc: Number(badges.rechazos_cc ?? nested.cc ?? 0),
  };
};
